const API = {
  TOKEN: {
    ACCESS: `api/token/`,
    REFRESH: `api/token/refresh/`
  },
  ROLES: {
    INDEX: `roles/`
  },
  CORE: {
    PROJECTS: {
      INDEX: `projects/`
    },
    PROJECT_USERS: {
      INDEX: `project_users/`
    },
    USERS: {
      INDEX: `users/`,
      CURRENT_USER: `users/current_user/`
    },
    SIMULATIONS: {
      INDEX: `simulations/`,
      DUPLICATE: (id: number) => `simulations/${id}/duplicate/`,
      BULK_DUPLICATE: `simulations/bulk_duplicate/`,
      EXPORT_EXCEL: (id: number) => `simulations/${id}/export_excel/`,
      CELERY_CALCULATE: (id: number) => `simulations/${id}/run_simulation/`,
      EXPORT_ERROR: (id: number) => `simulations/${id}/get_error_file/`,
      GET_CALCULATION_PROGRESS_STEPS: (id: number) =>
        `simulations/${id}/get_simulation_progress_steps/`,
      GET_CALCULATION_PROGRESS: (id: number) => `simulations/${id}/get_simulation_progress/`,
      GET_ARCGIS_LOCATION_PLATFORM_TOKEN: (id: number) =>
        `simulations/${id}/get_arcgis_location_platform_token/`
    }
  },
  MAP: {
    INDEX: `maps/`,
    GET_MAP_DETAIL: (id: number) => `maps/?simulation=${id}`,
    EXPORT_SHAPE_FILE: (id: number, type: string) =>
      `maps/${id}/export_result_file?export_as=${type}`
  },
  GENERATE_INPUT: {
    INDEX: `generate_input/`,
    GET_GENERATE_INPUT_DETAIL: (calculation_id: number) =>
      `generate_input/get_generate_input_data?simulation=${calculation_id}`
  }
}

export default API
